/**
 * section break component used in forms
 */
const SectionBreak = () => (
  <div
    className="border grid-2-wide"
    style={{ marginBottom: ".2rem", marginTop: ".2rem" }}
  ></div>
);

export default SectionBreak;
